import { Component } from '@angular/core';
import { getStatusMark } from 'src/app/const/entity-view-constants';
import { MarkerInfoState } from '../../shared/marker-info.state';

@Component({
  selector: 'app-community-project-marker',
  templateUrl: './community-project-marker.component.html',
  styleUrls: ['./community-project-marker.component.scss'],
})
export class CommunityProjectMarkerComponent extends MarkerInfoState {
  public getStatusMark(): string {
    return getStatusMark(this.data.status);
  }
}
